import Vue from 'vue'
import App from './App.vue'

// 引入路由
import router from './router'


import store from './store'
import ElementUI from 'element-ui';

import global_ from './utils/common';
import cookie_ from './views/components/cookie.vue';


Vue.config.errorHandler = function (err, vm, info) {
  // handle error
  // `info` 是 Vue 特定的错误信息，比如错误所在的生命周期钩子
  // 只在 2.2.0+ 可用
  console.log(err);
  console.log(vm);
  console.log(info);
}

Vue.prototype.GLOBAL = global_;
Vue.prototype.COOKIE = cookie_;

Vue.use(ElementUI);

Vue.config.productionTip = false

// 引入核心代码
import '@/core'

import '@/router/permission'



new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
